import { createSelector } from 'redux-starter-kit';

export default {
  list: createSelector(['assets.list']),
};
